import {
  CONFIRMED_GET_SERVICE_CALLER_LIST,
  CONFIRMED_GET_PATIENTS_LIST,
  CONFIRMED_REASSIGN_PATIENTS,
} from "../actions/ServiceCallerReassignmentTypes";

const initialState = {
  serviceCallerList: [],  // For dropdown
  patientsList: [],       // For patients table
  loading: false,
  error: null,
};

export default function ServiceCallerReassignmentReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_SERVICE_CALLER_LIST:
      return {
        ...state,
        serviceCallerList: action.payload,
        loading: false,
        error: null,
      };

    case CONFIRMED_GET_PATIENTS_LIST:
      return {
        ...state,
        patientsList: action.payload,
        loading: false,
        error: null,
      };

    case CONFIRMED_REASSIGN_PATIENTS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
}